'use client'

import Script from 'next/script'

export default function KakaoSDK() {
  return (
    <Script
      src="https://developers.kakao.com/sdk/js/kakao.js"
      strategy="afterInteractive"
      onLoad={() => {
        if (typeof window !== 'undefined' && (window as any).Kakao) {
          if (!(window as any).Kakao.isInitialized()) {
            (window as any).Kakao.init(process.env.NEXT_PUBLIC_KAKAO_JS_KEY || 'YOUR_KAKAO_JS_KEY')
          }
        }
      }}
    />
  )
}
